module.exports = __webpack_public_path__ + "img/i-phone-frame.c97a9e31.svg";